import {SET_PROFILE_SETTINGS} from "../actions/constants";
import {createReducer} from "../../../_common/common.ts";
import {SET_COMUNICADO_ADJUNTOS} from "../../comunicados/actions/constants";

export const profile_settings = createReducer(null, {
    [SET_PROFILE_SETTINGS]: (state, payload)=> payload
});
